import { useMemo } from 'react';
import type { Sort } from 'state/SimInventory/SimInventoryStore';
import useSimInventoryStoredSorts from 'state/SimInventory/useSimInventoryStoredSorts';

/**
 * Translation layer between Zustand state and SIM Inventory for sorts
 */

interface UseSimInventorySortsProps {
  defaultSort: Array<Sort>;
}

const useSimInventorySorts = ({ defaultSort }: UseSimInventorySortsProps) => {
  const sorts = useSimInventoryStoredSorts();

  return useMemo(() => {
    if (sorts.length === 0) {
      return defaultSort;
    }

    return [
      ...sorts,
      ...defaultSort.filter(
        (defaultSortValue) => !sorts.find((sort) => sort.property === defaultSortValue.property)
      ),
    ];
  }, [sorts, defaultSort]);
};

export default useSimInventorySorts;
